// header height adjustment

(function () {
	const header = document.querySelector('header');
	if (!header) return;

	// Function to update the CSS variable
	// Updates dynamically to account for:
	// - Responsive design (header height changes at different screen sizes)
	// - Admin bar (WordPress admin bar adds extra height)
	// - Dynamic content changes
	function updateHeaderHeight() {
		const height = header.offsetHeight;
		document.documentElement.style.setProperty('--header-height', `${height}px`);
	}

	// Debounce function for performance
	function debounce(func, wait = 100) {
		let timeout;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, arguments), wait);
		};
	}

	// Initial call
	updateHeaderHeight();

	// Update on load and resize (debounced)
	window.addEventListener('load', updateHeaderHeight);
	window.addEventListener('resize', debounce(updateHeaderHeight));
	
	// Update on scroll (debounced)
	window.addEventListener('scroll', debounce(updateHeaderHeight));

	// Optional: Watch for DOM changes in the header (MutationObserver)
	const observer = new MutationObserver(debounce(updateHeaderHeight));

	observer.observe(header, {
		childList: true, // watch for added/removed nodes
		subtree: true, // watch deeply
		attributes: true, // watch attribute changes (e.g. class change)
		characterData: true, // watch text changes (optional)
	});

	// Optional: Expose function globally for manual updates if needed
	window.updateHeaderHeight = updateHeaderHeight;
})();

// Cart dropdown functionality
(function () {
	const cartIcon = document.querySelector('.cart-icon');
	const cartDropdown = document.querySelector('.cart-dropdown');
	
	if (!cartIcon || !cartDropdown) return;

	// Mobile cart dropdown toggle
	function initCartDropdown() {
		// Only add click functionality on mobile
		if (window.innerWidth < 1024) {
			cartIcon.addEventListener('click', function(e) {
				e.preventDefault();
				
				// Toggle active class
				cartIcon.classList.toggle('active');
				
				// Close dropdown when clicking outside
				document.addEventListener('click', function closeDropdown(event) {
					if (!cartIcon.contains(event.target) && !cartDropdown.contains(event.target)) {
						cartIcon.classList.remove('active');
						document.removeEventListener('click', closeDropdown);
					}
				});
			});
		}
	}

	// Initialize on load
	initCartDropdown();

	// Re-initialize on resize
	window.addEventListener('resize', debounce(initCartDropdown, 250));

	// Debounce function (reuse from above)
	function debounce(func, wait = 100) {
		let timeout;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, arguments), wait);
		};
	}
})();
